export default __webpack_public_path__ + "static/logo.crrf-abb1f9339e3a952f44cb469e5f76c93c.png";